import React, { useContext, useState, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group';
import { GRASSDOOR } from '../../constants/website';
import ListFilterItem from './ListFilterItem';
import { useClearRefinements, useRefinementList } from 'react-instantsearch-hooks-web';
import appContext from '../../Context/appContext';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedPriceSort } from '../../redux/slices/searchSlice';

export const MobileFilter = ({ toggleFilterPopup, asapProductsCount, scheduledProductsCount, currentTab, isFilterPopupVisible }) => {

  // const {
  //   // state: {
  //   //   search: { selectedPriceSort }
  //   // },
  //   dispatch
  // } = useContext(appContext);
  const selectedPriceSort = useSelector(state => state.search.selectedPriceSort)
  const dispatchRedux = useDispatch()

  const { refine, canRefine } = useClearRefinements({
    includedAttributes: ['brands', 'full_shop_categories', 'strain', 'deviceType']
  });


  const hidePopup = e => {
    if (e.target.classList.value.split(' ').includes('modal')) {
      toggleFilterPopup(false);
    }
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    if (isFilterPopupVisible) {
      body.classList.add('modal-open');
    }
    else {
      body.classList.remove('modal-open');
    }
  }, [isFilterPopupVisible]);

  const [selectedFilter, setSelectedFilter] = useState({
    title: "Sort", attribute: 'sort', filterType: 'sort', type: 'radio'
  });

  const { items: strainItems } = useRefinementList({ attribute: 'strain', limit: 30 });
  const { items: brandItems } = useRefinementList({ attribute: 'brands', limit: 30 });
  const { items: categoryItems } = useRefinementList({ attribute: 'full_shop_categories', limit: 30 });
  const { items: deviceTypeItems } = useRefinementList({ attribute: 'deviceType', limit: 30 });

  const refinedStrainItems = strainItems.filter(item => item?.isRefined == true)?.length ?
    ` (${strainItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedBrandItems = brandItems.filter(item => item?.isRefined == true)?.length ?
    ` (${brandItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedCategoryItems = categoryItems.filter(item => item?.isRefined == true)?.length ?
    ` (${categoryItems.filter(item => item?.isRefined == true)?.length})` : '';

  const refinedDeviceTypeItems = deviceTypeItems.filter(item => item?.isRefined == true)?.length ?
    ` (${deviceTypeItems.filter(item => item?.isRefined == true)?.length})` : '';

  let filterList = [{
    title: "Sort", countLabel: '', attribute: 'sort', filterType: 'sort', type: 'radio'
  }];

  if (categoryItems?.length) {
    filterList.push({ title: `Categories`, countLabel: `${refinedCategoryItems}`, attribute: 'full_shop_categories', filterType: 'search', type: 'checkbox' })
  }
  if (brandItems?.length) {
    filterList.push({ title: `Brands`, countLabel: `${refinedBrandItems}`, attribute: 'brands', filterType: 'search', type: 'checkbox' })
  }
  if (deviceTypeItems?.length) {
    filterList.push({ title: `Device Types`, countLabel: `${refinedDeviceTypeItems}`, attribute: 'deviceType', filterType: 'search', type: 'checkbox' })
  }
  if (strainItems?.length) {
    filterList.push({ title: `Strain Types`, countLabel: `${refinedStrainItems}`, attribute: 'strain', filterType: 'search', type: 'checkbox' })
  }

  return (
    <CSSTransition appear in mountOnEnter unmountOnExit timeout={300} classNames="slideup-wrapper">
      <div
        className="modal filter-popup d-block  animated-popup-wrapper"
        tabIndex="-1"
        onClick={hidePopup}
        role="dialog"
      >
        <div className="modal-dialog  " role="document">
          <div className="modal-content">
            <div className="modal-header justify-content-between align-items-center pb-2 ">
              <h6 className="modal-title text-center bold">
                {process.env.NEXT_PUBLIC_APP == GRASSDOOR ? 'Filter and Sort' : 'Filters'}
              </h6>
              <div>
                <button type="button" className="btn " onClick={() => toggleFilterPopup(false)}>
                  <i className="icon-close" />
                </button>
              </div>
            </div>
            <div className="modal-body py-0">
              <div className="sidebarContent new-filters">
                <div className="sidebarBanner d-flex align-items-center justify-content-between">
                  <h6 className="title m-0 bold text-primary relative">
                    {process.env.NEXT_PUBLIC_APP == GRASSDOOR ? 'FILTER AND SORT' : 'Filters'}
                  </h6>
                  <button className="btn btn-link clear-btn" onClick={() => toggleFilterPopup(false)}>
                    Clear
                  </button>
                </div>
                <div className="filter-sec-parent">
                  <div className='filters-left' >
                    <div className='filters-b'>
                      {
                        filterList.map((item) => (
                          <div key={item.attribute}
                            onClick={() => setSelectedFilter(item)}
                            className={`filters-prop ${selectedFilter.attribute === item.attribute ? "filter-selected" : "not-selected-filter"}`}>
                            {item.title}{item.countLabel}
                          </div>
                        ))
                      }
                    </div>
                  </div>
                  {
                    filterList.map((item) => (
                      <div className={`filters-right  ${selectedFilter.attribute === item.attribute ? "" : "d-none"}`}>
                        <ListFilterItem
                          filter={item}
                        />
                      </div>
                    ))
                  }
                </div >
              </div >
            </div>
            <div className="modal-footer">
              <div className="d-flex justify-content-between is-fullwidth">
                <button
                  disabled={!selectedPriceSort && !canRefine}
                  type="button" className="btn btn-outline min-width-btn"
                  onClick={() => {
                    refine();
                    // dispatch({ type: 'setSelectedPriceSort', payload: '' });

                    dispatchRedux(setSelectedPriceSort(''))

                  }}
                >
                  Clear Filters
                </button>
                <button type="button" className="btn btn-primary min-width-btn"
                  onClick={() => toggleFilterPopup(false)}
                >
                  Show
                  {' '}
                  {currentTab === 'asap' ? asapProductsCount : scheduledProductsCount} Products
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </CSSTransition >
  )

}
